// extracted by css-extract-rspack-plugin
module.exports =  {"weatherAqiReports":"lsEez","pollutionBar":"dWN6T","ringIcon":"twWvM"};